import { ItemList } from '../../orm'

class AdminOutgoingFaxServiceProviderList extends ItemList {
    getEntityKey() {
        return "admin/outgoing_fax_service_provider"
    }
}

export const adminOutgoingFaxServiceProviderList = new AdminOutgoingFaxServiceProviderList("admin_outgoing_fax_service_provider__default")
